export const TextRotationList = [
  { value: '0', label: '0度' },
  { value: '45', label: '45度' },
  { value: '90', label: '90度' },
  { value: '135', label: '135度' },
  { value: '180', label: '180度' },
  { value: '225', label: '225度' },
  { value: '270', label: '270度' },
  { value: '315', label: '315度' },
]